import { render, staticRenderFns } from "./ScreenOne.vue?vue&type=template&id=55d75bcb&"
import script from "./ScreenOne.vue?vue&type=script&lang=js&"
export * from "./ScreenOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports